import { useAuthAppStore } from "@/store/stores/authStore";

export class ProductCatalogService {
  async getAllEntities({ productManagementServiceClient }) {
    var response = await productManagementServiceClient.get({
      route: "/product-catalog/get-all-entities",
      // params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getProductCatalogByPKey({
    productManagementServiceClient,
    params,
  }) {
    var paramsBase = {
      PKey: params.PKey,
    };

    var response = await productManagementServiceClient.get({
      route: "/product-catalog/get-entity-by-pkey",
      params: paramsBase,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }
}
